import { Component } from '@angular/core';

@Component({
  selector: 'app-capture-history-item-body',
  template: '<div><ng-content /></div>',
  standalone: false
})
export class CaptureHistoryItemBodyComponent {}
